"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWaterQualityStatus = void 0;
const types_1 = require("../../types");
const getWaterQualityStatus = (value, labelProvider) => {
    // value is EC (µS/cm). Convert to TDS (ppm) and band against drinking-water guidance.
    const tds = Math.round(value * 0.6);
    const qualityScaleMax = types_1.WaterQualityThreshold.concerning;
    const percentage = Math.max(0, Math.min(100, Math.round((1 - tds / qualityScaleMax) * 100)));
    const pick = (threshold, color) => ({
        value,
        percentage,
        tds,
        threshold,
        color,
        label: labelProvider(threshold),
    });
    if (tds <= types_1.WaterQualityThreshold.excellent)
        return pick(types_1.WaterQualityThreshold.excellent, types_1.WaterQualityColor.Blue);
    if (tds <= types_1.WaterQualityThreshold.good)
        return pick(types_1.WaterQualityThreshold.good, types_1.WaterQualityColor.Blue);
    if (tds <= types_1.WaterQualityThreshold.acceptable)
        return pick(types_1.WaterQualityThreshold.acceptable, types_1.WaterQualityColor.Blue);
    if (tds <= types_1.WaterQualityThreshold.hard)
        return pick(types_1.WaterQualityThreshold.hard, types_1.WaterQualityColor.Yellow);
    return pick(types_1.WaterQualityThreshold.concerning, types_1.WaterQualityColor.Red);
};
exports.getWaterQualityStatus = getWaterQualityStatus;
